import React, { useState, useEffect, createRef, useRef } from 'react'

import { shallowEqual, useDispatch, useSelector } from 'react-redux'
// import VisibilitySensor from 'react-visibility-sensor'
import styled from 'styled-components'

import { listTestimonials } from '../../_actions'
import { scrollTo, useEventListener, useWindowSize } from '../../_helpers'
import {
    // Container,
    devices,
    colors,
    Title,
} from '../Common'

const TestimonialList = ({ list, mobile }) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const len = list.length;
    const [listRefs, setListRefs] = useState([])
    const containerRef = useRef()

    useEffect(() => {
        setListRefs(listRefs => Array(len).fill().map((_, i) => listRefs[i] || createRef()))
    }, [len])

    const dotScroll = i => {
        setActiveSlide(i)
        scrollTo(listRefs[i].current.offsetTop, 500, containerRef.current)
    }

    const updateDots = () => {
        
    }

    useEventListener('scroll', updateDots, containerRef.current)

    return (
        <>
            <CarouselContainer ref={containerRef}>
                {list.map((t, i) =>
                        <Testimonial key={t.name} ref={listRefs[i]} color={(i + 1) % 2 === 0 ? colors.red : colors.black}>
                            {i === 0 && <PageTitle fontSize={26}>Testimonials</PageTitle>}
                            <Text>
                                {t.image && <img src={t.image} />}
                                <Content>{`"${t.content}"`}</Content>
                                <NameAndTitle color={(i + 1) % 2 === 0 ? colors.black : colors.red}>{t.name} / {t.title}</NameAndTitle>
                            </Text>
                        </Testimonial>
                )}
            </CarouselContainer>
            {!mobile &&
                <Dots>
                    {list.map((t, i) =>
                        <Dot key={i} role='button' onClick={() => dotScroll(i)} active={i === activeSlide} aria-label={`Testimonial ${i}`} />
                    )}
                    <Count>{activeSlide + 1} / {list.length}</Count>
                </Dots>
            }
        </>
    )
}

const Testimonials = () => {
    const { testimonials } = useSelector(state => state.content, shallowEqual)
    const dispatch = useDispatch()
    const { width } = useWindowSize()
    const mobile = width < 940

    useEffect(() => {
        dispatch(listTestimonials())
    }, [])

    return <TestimonialList list={testimonials} mobile={mobile} />
}

const CarouselContainer = styled.div`
    position: relative;
    height: 100vh;
    overflow-y: auto;

    /* hide scrollbar */
    -ms-overflow-style: none;
    scrollbar-width: none; 

    &::-webkit-scrollbar {
        display: none;
    }
`

const Text = styled.div`
    width: 95%;

    @media ${devices.small} {
        width: 100%;
    }
`

const PageTitle = styled(Title)`
    position: absolute;
    top: 50px;
    @media ${devices.small} {
        top: 30px;
    }
`

const Testimonial = styled.div`
    background: ${({ color }) => color};
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 100px;

    img {
        width: 150px !important;
        height: 150px;
        border-radius: 50%;
    }
    
    @media ${devices.small} {
        position: relative;
        padding: 30px 20px;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        /* height: 87vh; */
        height: calc(95vh - 60px);
        
        img {
            width: 80px !important;
            height: 80px;
            margin-bottom: 40px;
        }
    }
`

const Content = styled.div`
    color: ${colors.white};
    font-size: 30px;
    font-family: pragmatica, sans-serif;
    font-weight: 700;
    font-style: normal;
    text-align: left;
    margin-bottom: 50px;

    @media ${devices.small} {
        font-size: 18px;
    }
`

const NameAndTitle = styled.div`
    text-transform: uppercase;
    color: ${({ color }) => color};
    font-size: 15px;
    font-family: pragmatica, sans-serif;
    font-weight: 700;
    font-style: normal;
    text-align: left;
    letter-spacing: 2px;

    @media ${devices.small} {
        font-size: 8px;
        line-height: 1.5;
    }
`

const Dots = styled.div`
    margin-top: 20px;
    text-align: center;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    position: absolute;
    top: 20%;
    right: 25px;

    @media ${devices.small} {
        display: none;
    }
`

const Dot = styled.div`
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 16px;
    margin-bottom: 17px;
    background: ${colors.white};
    opacity: ${({ active }) => active ? 1 : 0.5};
    cursor: pointer;
`

const Count = styled.div`
    color: ${colors.white};
    font-family: pragmatica, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 8px;
`

export default Testimonials